export const GET_COMMUNICATIONS_REQUEST = 'GET_COMMUNICATIONS_REQUEST';
export const GET_COMMUNICATIONS_SUCCESS = 'GET_COMMUNICATIONS_SUCCESS';
export const GET_COMMUNICATIONS_FAILURE = 'GET_COMMUNICATIONS_FAILURE';

export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';

export const GET_COMMUNICATION_NOTIFICATION_REQUEST = 'GET_COMMUNICATION_NOTIFICATION_REQUEST';
export const GET_COMMUNICATION_NOTIFICATION_SUCCESS = 'GET_COMMUNICATION_NOTIFICATION_SUCCESS';
export const GET_COMMUNICATION_NOTIFICATION_FAILURE = 'GET_COMMUNICATION_NOTIFICATION_FAILURE';

export const GET_ALL_OTHER_COMMUNICATIONS_REQUEST = 'GET_ALL_OTHER_COMMUNICATIONS_REQUEST';
export const GET_ALL_OTHER_COMMUNICATIONS_SUCCESS = 'GET_ALL_OTHER_COMMUNICATIONS_SUCCESS';
export const GET_ALL_OTHER_COMMUNICATIONS_FAILURE = 'GET_ALL_OTHER_COMMUNICATIONS_FAILURE';

export const LOG_NOTIFICATION_VIEW_REQUEST = "LOG_NOTIFICATION_VIEW_REQUEST";